import Header from "../../../layouts/header";
import golf from "../../../assets/images/2025-Program/golf-ball-flag.jpg";

import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { Nav } from "../../../layouts/navbar/nav";
import images from "../../../constant/images";
import sinta from "../../../assets/images/GTM-APP-icons/gold-sinta.png";
import { FaLocationDot } from "react-icons/fa6";
import { RiVipCrownFill } from "react-icons/ri";

import { FcCalendar } from "react-icons/fc";
import crown from "../../../assets/images/GTM-APP-icons/gold_crown.png";
import data from "../../../json/events.json";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { MdCalendarMonth } from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function Program() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [user, setUser] = useState();
  const [member, setMember] = useState(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [pack, setPack] = useState(null);
  const [isEventsLoading, setIsEventsLoading] = useState(true);
  const [isGolfer, setIsGolfer] = useState(null);
  const [membership, setMembership] = useState(null);
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const [showFinished, setShowFinished] = useState(false);
  const language = localStorage.getItem("i18nextLng");

  const [finishedEvents, setFinishedEvents] = useState(null);
  const [events, setEvents] = useState(null);
  const [thisMonthEvents, setThisMonthEvents] = useState(null);
  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);
        setIsGolfer(response.data.golfeurs);

        if (response.data?.membership?.status === "valid") {
          setMember(response.data.membership);
          setPack(response.data.membership?.membership_packs);
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);
  const fetchEvents = useCallback(async () => {
    try {
      setIsEventsLoading(true);
      const response = await axios.get(`${baseUrl}/events`);
      setEvents(response.data.events);
      const today = new Date();
      const currentDate = today.toISOString().split("T")[0];
      const currentMonth = currentDate.split("-")[1];
      const happened = response.data.events
        .filter((event) => event?.date < currentDate)
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      const yetToCome = response.data.events.filter(
        (event) => event?.date >= currentDate
      );

      const thisMonth = response.data.events.filter(
        (event) =>
          event?.date >= currentDate &&
          event?.date.split("-")[1] == currentMonth
      );
      setEvents(yetToCome);
      setFinishedEvents(happened);
      setThisMonthEvents(thisMonth);
    } catch (error) {
    } finally {
      setIsEventsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchEvents();
    fetchUser();
    // return () => {
    //   setPack(null);
    // };
  }, [fetchEvents, fetchUser]);

  useEffect(() => {}, [isGolfer, user]);

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.background}`;
    }

    return "https://sysgtm.gtm.ma//images/packs/visitor-menu.png";
  };
  const imagess2 = getimagess(membership?.membership_packs?.background);

  const eventsTarget = () => {
    const displayedEvents = showAll ? events : events?.slice(0, 3);

    return (
      <>
        {(() => {
          // if (thisMonthEvents.length > 0) {
          //   return (
          //     <div style={{ overflowY: "auto" }}>
          //       <div style={{ margin: "20px 0" }}>
          //         <h3 className="font-bold text-lg mb-4 px-4">This month</h3>
          //         {!isEventsLoading &&
          //           thisMonthEvents &&
          //           thisMonthEvents?.map((item) => (
          //             <div
          //               key={item.id}
          //               onClick={() => {
          //                 console.log(`Passing isGolfer: ${user?.golfeurs}`);
          //                 console.log(
          //                   `Passing membership: ${user?.membership}`
          //                 );
          //                 console.log(`Passing memberId: ${member?.id}`);
          //                 const navState = {
          //                   isGolfer: user?.golfeurs,
          //                   eventId: item.id,
          //                   pack: pack?.name || "golfer+",
          //                   memberId: member?.id,
          //                   membershipId: member?.membership_id,
          //                 };
          //                 console.log(
          //                   "Verified navigation state:hhhhhhhhhhhhhhhhhh",
          //                   navState
          //                 );
          //                 navigate("/membership/show_events", {
          //                   state: {
          //                     isGolfer: user?.golfeurs,
          //                     eventId: item.id,
          //                     pack: pack?.name,
          //                     memberId: member?.id,
          //                     membershipId: member?.membership_id,
          //                   },
          //                 });
          //               }}
          //               className="bg-[#f0f5ec] hover:opacity-70 rounded-lg overflow-hidden mt-2 cursor-pointer relative"
          //             >
          //               {item.sold_out == 1 && (
          //                 <img
          //                   src={images.sold_out}
          //                   alt="sold out"
          //                   className="absolute right-0 top-0 h-[130px] w-[150px] z-10"
          //                 />
          //               )}
          //               <div className="p-5 flex">
          //                 {/* Event Details */}
          //                 <div className="flex flex-col gap-3 flex-1">
          //                   <div className="lg:font-bold font-bold lg:text-xl text-sm ">
          //                     {item.title}
          //                   </div>
          //                   <p className="text-xs text-gray-600 mb-2 line-clamp-2">
          //                     {item.details}
          //                   </p>
          //                   <div className="flex items-center gap-1">
          //                     <FaLocationDot color="red" />
          //                     <span className="text-blue-500 lg:text-sm text-[12px]">
          //                       {item.venue}
          //                     </span>
          //                   </div>
          //                 </div>
          //                 {/* Date and Icon Section */}
          //                 {/* Date and Icon Section */}
          //                 <div className="flex flex-col justify-between">
          //                   {/* Optional Image, like crown */}
          //                   <img
          //                     className="self-end"
          //                     src={crown}
          //                     width={30}
          //                     alt=""
          //                   />
          //                   {/* Date section with date first, then calendar icon */}
          //                   <div className="flex items-end gap-3 text-2xl font-bold">
          //                     {/* Date display comes first */}
          //                     <div className="relative flex text-gray-700 flex-col">
          //                       <span className="absolute text-end bottom-4 md:bottom-5 right-0 text-sm md:text-base ">
          //                         {item.hide_date == 0 &&
          //                           item.date.split("-")[2]}
          //                       </span>
          //                       <span className="text-sm md:text-base">
          //                         {(() => {
          //                           const month = item.date.split("-")[1];
          //                           switch (month) {
          //                             case "01":
          //                               return "JAN";
          //                             case "02":
          //                               return "FEB";
          //                             case "03":
          //                               return "MAR";
          //                             case "04":
          //                               return "APR";
          //                             case "05":
          //                               return "MAY";
          //                             case "06":
          //                               return "JUN";
          //                             case "07":
          //                               return "JUL";
          //                             case "08":
          //                               return "AUG";
          //                             case "09":
          //                               return "SEP";
          //                             case "10":
          //                               return "OCT";
          //                             case "11":
          //                               return "NOV";
          //                             case "12":
          //                               return "DEC";
          //                             default:
          //                               return "---";
          //                           }
          //                         })()}
          //                       </span>
          //                     </div>
          //                     <FcCalendar size={40} />
          //                   </div>
          //                 </div>
          //               </div>
          //               {/* Background Image Section */}
          //               <div
          //                 style={{
          //                   height: "10px",
          //                   width: "100%",
          //                   marginTop: "10px",
          //                   borderBottomLeftRadius: "5px",
          //                   borderBottomRightRadius: "5px",
          //                   backgroundColor: imagess2,
          //                   backgroundSize: "cover",
          //                   backgroundPosition: "center",
          //                 }}
          //               ></div>
          //             </div>
          //           ))}
          //       </div>
          //     </div>
          //   );
          // }
        })()}
        <div style={{ overflowY: "auto" }}>
          <div style={{ margin: "0px 0" }} className="">
            <h3 className="font-bold text-lg mb-4 px-4">{language === "fr" ? "Événements à venir" : "Upcoming events"}</h3>
            <div className="space-y-4">
              {!isEventsLoading &&
                events &&
                displayedEvents?.map((item) => (
                  <div
                    key={item.id}
                    onClick={isLoading ? null : () => {
                      const navState = {
                        isGolfer: user?.golfeurs,
                        eventId: item.id,
                        pack: pack?.name ,
                        memberId: member?.id,
                        membershipId: member?.membership_id,
                      };
                      console.log("navStategggggggggggg", navState);

                      navigate("/gtmclub/2025program/show_events", {
                        state: navState,
                      });
                    }}
                    className="bg-[#f0f5ec] hover:opacity-70 hover:shadow-lg rounded-lg overflow-hidden  cursor-pointer relative"
                  >
                    {item.sold_out == 1 && (
                      <img
                        src={images.sold_out}
                        alt="sold out"
                        className="absolute right-0 top-0 h-[130px] w-[150px] z-10"
                      />
                    )}

                    <div className="p-5 flex">
                      {/* Event Details */}
                      <div className="flex flex-col gap-3 flex-1">
                        <div className="lg:font-bold font-bold lg:text-xl text-sm ">
                          {item.title}
                        </div>
                        <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                          {item.details}
                        </p>
                        <div className="flex items-center gap-1">
                          <FaLocationDot color="red" />
                          <span className="text-blue-500 lg:text-sm text-[12px]">
                            {item.venue}
                          </span>
                        </div>
                      </div>
                      {/* Date and Icon Section */}
                      {/* Date and Icon Section */}
                      <div className="flex flex-col justify-between">
                        {/* Optional Image, like crown */}
                        <img
                          className="self-end"
                          src={crown}
                          width={30}
                          alt=""
                        />

                        {/* Date section with date first, then calendar icon */}
                        <div className="flex items-end gap-3 text-2xl font-bold">
                          {/* Date display comes first */}
                          <div className="relative flex text-gray-700 flex-col">
                            <span className="absolute text-end bottom-4 md:bottom-5 right-0 text-sm md:text-base ">
                              {item.hide_date == 0 && item.date.split("-")[2]}
                            </span>
                            <span className="text-sm md:text-base">
                              {(() => {
                                const month = item.date.split("-")[1];
                                switch (month) {
                                  case "01":
                                    return "JAN";
                                  case "02":
                                    return "FEB";
                                  case "03":
                                    return "MAR";
                                  case "04":
                                    return "APR";
                                  case "05":
                                    return "MAY";
                                  case "06":
                                    return "JUN";
                                  case "07":
                                    return "JUL";
                                  case "08":
                                    return "AUG";
                                  case "09":
                                    return "SEP";
                                  case "10":
                                    return "OCT";
                                  case "11":
                                    return "NOV";
                                  case "12":
                                    return "DEC";
                                  default:
                                    return "---";
                                }
                              })()}
                            </span>
                          </div>

                          <FcCalendar size={40} />
                        </div>
                      </div>
                    </div>

                    {/* Background Image Section */}
                    <div
                        style={{
                          height: "15px",
                          width: "100%",
                          marginTop: "10px",
                          borderBottomLeftRadius: "5px",
                          borderBottomRightRadius: "5px",
                          backgroundImage: imagess2
                            ? `url(${imagess2})`
                            : `url(https://sysgtm.gtm.ma//images/packs/visitor-menu.png)`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                    ></div>
                  </div>
                ))}
            </div>

            {
              <div
                onClick={() => setShowAll(!showAll)}
                className="flex cursor-pointer flex-col gap-2 justify-center items-center mt-5"
              >
                {!showAll && events.length > 3 ? (
                  <IoIosArrowDown size={50} />
                ) : (
                  <IoIosArrowUp size={50} />
                )}

                <div className="text-[#0D70A1] text-xl font-bold">
                  {!showAll && events.length > 3
                    ? language === "fr" 
                      ? "Afficher plus d'événements"
                      : "Show more events"
                    : language === "fr"
                      ? "Réduire"
                      : "Minimize"}
                </div>
              </div>
            }
            
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <Header image={golf} title={t("gtm_club_content.programme")} />
      <div className="flex justify-center items-center">
        <div className="h-full flex flex-col justify-start items-center gap-4 md:gap-4 w-full md:w-[75%] px-8 mb-20">
          <div className="flex flex-col gap-4 md:gap-8 w-full">
            <div className="w-full">
              <div className="flex justify-center items-center mb-4"></div>
              {isEventsLoading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
                </div>
              ) : (
                <div className="space-y-8">
                  {eventsTarget()}
                  {finishedEvents?.length > 0 && (
                    <div className="mt-10">
                      <h3 className="font-bold text-lg mb-4 px-4">
                        {t("dashboard.already")}
                      </h3>
                      <div className="space-y-4">
                        {(showFinished ? finishedEvents : finishedEvents?.slice(0, 3))?.map((item) => (
                          <div
                            key={item.id}
                            className="bg-gray-200 hover:opacity-50 opacity-80 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] rounded-lg overflow-hidden mt-2 cursor-pointer relative"
                          >
                            {/* Sold Out Indicator */}
                            {item.sold_out == 1 && (
                              <img
                                src={images.sold_out}
                                alt="sold out"
                                className="absolute right-0 top-0 h-[130px] w-[150px] z-10"
                              />
                            )}

                            <div className="p-5 flex">
                              {/* Event Details */}
                              <div className="flex flex-col gap-3 flex-1">
                                <div className="lg:font-bold font-semibold lg:text-xl">
                                  {item.title}
                                </div>
                                <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                                  {item.details}
                                </p>
                                <div className="flex items-center gap-1">
                                  <FaLocationDot color="gray" />
                                  <span className="text-gray-500 text-sm">
                                    {item.venue}
                                  </span>
                                </div>
                              </div>

                              {/* Date and Icon Section */}
                              {/* Date and Icon Section */}
                              <div className="flex flex-col justify-between">
                                {/* Optional Image, like crown */}
                                <RiVipCrownFill
                                  className="self-end opacity-35"
                                  size={30}
                                />

                                {/* Date section with date first, then calendar icon */}
                                <div className="flex items-end gap-3 text-2xl font-bold">
                                  {/* Date display comes first */}
                                  <div className="relative flex text-gray-700 flex-col">
                                    <span className="absolute text-end bottom-4 md:bottom-5 right-0 text-sm md:text-base">
                                      {item.hide_date == 0 &&
                                        item.date.split("-")[2]}
                                    </span>
                                    <span className="text-sm md:text-base">
                                      {(() => {
                                        const month = item.date.split("-")[1];
                                        switch (month) {
                                          case "01":
                                            return "JAN";
                                          case "02":
                                            return "FEB";
                                          case "03":
                                            return "MAR";
                                          case "04":
                                            return "APR";
                                          case "05":
                                            return "MAY";
                                          case "06":
                                            return "JUN";
                                          case "07":
                                            return "JUL";
                                          case "08":
                                            return "AUG";
                                          case "09":
                                            return "SEP";
                                          case "10":
                                            return "OCT";
                                          case "11":
                                            return "NOV";
                                          case "12":
                                            return "DEC";
                                          default:
                                            return "---";
                                        }
                                      })()}
                                    </span>
                                  </div>

                                  {/* Calendar icon comes second */}
                                  <MdCalendarMonth size={40} color="gray" />
                                </div>
                              </div>
                            </div>

                            {/* Background Image Section */}
                            <div
                            style={{
                              height: "15px",
                              width: "100%",
                              marginTop: "10px",
                              borderBottomLeftRadius: "5px",
                              borderBottomRightRadius: "5px",
                              backgroundImage: imagess2
                                ? `url(${imagess2})`
                                : `url(https://sysgtm.gtm.ma//images/packs/visitor-menu.png)`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                            }}
                            ></div>
                          </div>
                        ))}
                      </div>
                      {finishedEvents?.length > 3 && (
                        <div
                          onClick={() => setShowFinished(!showFinished)}
                          className="flex cursor-pointer flex-col gap-2 justify-center items-center mt-5"
                        >
                          {!showFinished ? (
                            <IoIosArrowDown size={50} />
                          ) : (
                            <IoIosArrowUp size={50} />
                          )}

                          <div className="text-[#0D70A1] text-xl font-bold">
                            {!showFinished
                              ? language === "fr" 
                                ? "Afficher plus d'événements passés"
                                : "Show more past events"
                              : language === "fr"
                                ? "Réduire"
                                : "Minimize"}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
